import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad } from '@angular/router';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

    constructor(private _authService: AuthService) { }

    canActivate(): boolean {
        if (this._authService.isLoggedIn()) {
            return true;
        }
        this._authService.startAuthentication();
        return false;
    }

    canLoad(): boolean {
        if (this._authService.isLoggedIn()) {
            return true;
        }
        this._authService.startAuthentication();
        return false;
    }

    canActivateChild() {
        if (this._authService.isLoggedIn()) {
            return true;
        }
        this._authService.startAuthentication();
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/auth-guard.service.ts